import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import PlanAssessmentForm from "./PlanAssessmentForm";
import PlanChangesForm from "./PlanChangesForm";

export default function AssessmentPlanningForm(props) {
    const [activeTab, setActiveTab] = useState(props.defaultTab)
    
    const isTab2Disabled = (programId, sloId) => {
        if (programId && 
            props.step5Tab1DataStore 
            && (programId in props.step5Tab1DataStore)) {
            let tab1Data = props.step5Tab1DataStore[programId]
            if (sloId in tab1Data) {
                return false
            }
        }
        return true
    }
    
    return (
        <React.Fragment>
            <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                id="assessment_planning_tabs"
                className="mb-3"
                fill
                >
                <Tab
                    eventKey="tab-1"
                    title="Plan Changes"
                    >
                    <PlanChangesForm 
                        department={props.department}
                        selectedProgram={props.selectedProgram}
                        selectedLearningOutcome={props.selectedLearningOutcome}
                        learningOutcomes={props.learningOutcomes}
                        handleLearningOutcomeChanged={props.handleLearningOutcomeChanged}
                        theme={props.theme}
                        stepData={props.stepTab1Data}
                        sloQuestions={props.sloQuestions}
                        step1DataStore={props.step1DataStore}
                        step2DataStore={props.step2DataStore}
                        step4DataStore={props.step4DataStore}
                        step1CompletionData={props.step1CompletionData}
                        step2CompletionData={props.step2CompletionData}
                        step3CompletionData={props.step3CompletionData}
                        step4CompletionData={props.step4CompletionData}
                        stepCompletionData={props.stepCompletionData}
                        formDisabled={props.formDisabled}
                        handleS5Q30Changed={props.handleS5Q30Changed}
                        handleS5Q1Changed={props.handleS5Q1Changed}
                        handleS5Q2Changed={props.handleS5Q2Changed}
                        handleS5Q3Changed={props.handleS5Q3Changed}
                        handleS5Q4Changed={props.handleS5Q4Changed}
                        handleS5Q5Changed={props.handleS5Q5Changed}
                        handleS5Q6Changed={props.handleS5Q6Changed}
                        handleS5Q7Changed={props.handleS5Q7Changed}
                        handleS5Q8Changed={props.handleS5Q8Changed}
                        handleS5Q9Changed={props.handleS5Q9Changed}
                        handleS5Q10Changed={props.handleS5Q10Changed}
                        handleS5Q11Changed={props.handleS5Q11Changed}
                        handleS5Q12Changed={props.handleS5Q12Changed}
                        handleS5Q13Changed={props.handleS5Q13Changed}
                        handleS5Q14Changed={props.handleS5Q14Changed}
                        handleS5Q15Changed={props.handleS5Q15Changed}
                        />
                </Tab>
                <Tab
                    eventKey="tab-2"
                    title="Plan Assessment"
                    disabled={isTab2Disabled(props.selectedProgram?.programId, props.selectedLearningOutcome?.sloId)}
                    >
                    <PlanAssessmentForm 
                        department={props.department}
                        selectedProgram={props.selectedProgram}
                        selectedLearningOutcome={props.selectedLearningOutcome}
                        learningOutcomes={props.learningOutcomes}
                        handleLearningOutcomeChanged={props.handleLearningOutcomeChanged}
                        theme={props.theme}
                        stepData={props.stepTab2Data}
                        step5Tab1DataStore={props.step5Tab1DataStore}
                        step5Tab2DataStore={props.step5Tab2DataStore}
                        sloQuestions={props.sloQuestions}
                        step1DataStore={props.step1DataStore}
                        step2DataStore={props.step2DataStore}
                        step4DataStore={props.step4DataStore}
                        step1CompletionData={props.step1CompletionData}
                        step2CompletionData={props.step2CompletionData}
                        step3CompletionData={props.step3CompletionData}
                        step4CompletionData={props.step4CompletionData}
                        formDisabled={props.formDisabled}
                        stepCompletionData={props.stepCompletionData}
                        handleS5Q15Changed={props.handleS5Q15Changed}
                        handleS5Q16Changed={props.handleS5Q16Changed}
                        handleS5Q17Changed={props.handleS5Q17Changed}
                        handleS5Q18Changed={props.handleS5Q18Changed}
                        handleS5Q19Changed={props.handleS5Q19Changed}
                        handleS5Q20Changed={props.handleS5Q20Changed}
                        />
                </Tab>
                
            </Tabs>
        </React.Fragment>
    )
}